/**
 * Responsive, touch friendly image lightbox.
 * This module requires PhotoSwipe, so make sure to include it before initializing.
 * http://photoswipe.com/documentation/getting-started.html
 *
 * Used in conjunction with styles/objects/_photoswipe.scss
 *
 * Markup example:
 * ```
 * <!-- image without meta data -->
 * <a class="en-photoswipe-trigger" href="image-large-1.jpg"><img src="thumbnail-1.jpg" alt="thumbnail" /></a>
 *
 * <!-- image with meta data -->
 * <a class="en-photoswipe-trigger" href="image-large-2.jpg" data-en-photoswipe-caption="My image title" data-en-photoswipe-description="My image description"><img src="thumbnail-2.jpg" alt="thumbnail" /></a>
 * </ul>
 * ```
 *
 * Implementation example:
 * ```
 * EN.PhotoSwipe.init();
 * ```
 *
 * @module PhotoSwipe
 * @author EN GARDE (David Hell)
 * @version 1.1
 *
 * @requires PhotoSwipe (http://photoswipe.com/documentation/getting-started.html)
 *
 * Changelog:
 * 	1.1		added data-en-photoswipe-start-index to define custom starting point
 * 	1.0		initial version
 */

var EN = EN || {};

EN.PhotoSwipe = (function ($, PhotoSwipePlugin, PhotoSwipePluginUI, lodash) {
	'use strict';

	var defaults = {
		selectors: {
			trigger: '.en-photoswipe-trigger',
			scope: '.en-photoswipe-group',
			photoSwipeElement: '.pswp',
			photoSwipeBullets: '.pswp__bullets'
		},
		classNames: {
			bullet: 'pswp__bullet',
			active: 'en-is-active'
		},
		dataAttributes: {
			url: 'data-en-photoswipe-url',
			originalImageUrl: 'data-en-photoswipe-original-url', // used for download buttons
			width: 'data-en-photoswipe-width',
			height: 'data-en-photoswipe-height',
			title: 'data-en-photoswipe-title',
			html: 'data-en-photoswipe-html',
			startIndex: 'data-en-photoswipe-start-index'
		},
		callbacks: {
			itemFromElement: function ($element, index, options) {
				var data = {
					src: $element.attr(options.dataAttributes.url),
					w: $element.attr(options.dataAttributes.width),
					h: $element.attr(options.dataAttributes.height),
					title: $element.attr(options.dataAttributes.title),
					html: $element.attr(options.dataAttributes.html),
					enOriginalImageUrl: $element.attr(options.dataAttributes.originalImageUrl), // Photoswipe non-standard property, therefore prefixed
				};
				return data.src || data.html ? data : undefined;
			}
		},
		photoSwipe: {
			// Core Options
			// see http://photoswipe.com/documentation/options.html
			index: 0,
			escKey: true,
			showHideOpacity: true,
			history: true,

			// Default UI Options
			shareEl: false,
			fullscreenEl: true,
			barsSize: {
				top: 56,
				bottom: 'auto'
			},
			preload: [1, 2],
			timeToIdle: 2000,
		}
	};
	var photoSwipeElement, photoSwipeInstance, options;
	var imagesPreloaded = 0;
	var $downloadBtn = $('.en-pswp__download');
	var $iframeWrapper = null;


	/**
	 * Creates custom navigation bullets for the current PhotoSwipe element.
	 * @param {number} bulletNumber - Number of bullets to create.
	 * @return {jQuery}
	 */
	var createBullets = function (bulletNumber) {
		if (!photoSwipeElement || !photoSwipeInstance || typeof bulletNumber !== 'number' || bulletNumber < 2) return;

		var $bulletsContainer = $(photoSwipeElement).find(options.selectors.photoSwipeBullets);
		var html = '';
		var $bullets;
		var i;

		for (i = 0; i < bulletNumber; i++) {
			html += '<li class="' + options.classNames.bullet + (i === photoSwipeInstance.getCurrentIndex() ? ' ' + options.classNames.active : '') + '"></li>';
		}

		photoSwipeInstance.listen('beforeChange', function () {
			$bullets.eq(photoSwipeInstance.getCurrentIndex()).addClass(options.classNames.active).siblings().removeClass(options.classNames.active);
		});

		$bullets = $(html);
		$bulletsContainer.html($bullets);

		return $bullets;
	};

	/**
	 * Show PhotoSlide element. Make sure to add it to the DOM before.
	 * @memberof module:PhotoSwipe
	 * @param {jQuery} $elements - Set of anchor elements to create the lightbox from.
	 * @param {number} [startIndex=0] - (Zero-based) index of the element to be shown first.
	 * @return {PhotoSwipe}
	 */
	var open = function ($elements, index) {
		if (!photoSwipeElement) return;

		var photoSwipeItems = getPhotoSwipeItemsFromElements($elements);
		var photoSwipeOptions = $.extend({}, options.photoSwipe);

		if (index && index < photoSwipeItems.length) photoSwipeOptions.index = index;

		photoSwipeInstance = new PhotoSwipePlugin(photoSwipeElement, PhotoSwipePluginUI, photoSwipeItems, photoSwipeOptions);
		photoSwipeInstance.init();

		// Set href for the download button when opening lightbox and everytime when the slide changes to the next/prev image
		if (photoSwipeInstance.currItem.src) {
			$downloadBtn.attr('href', photoSwipeInstance.currItem.enOriginalImageUrl || photoSwipeInstance.currItem.src);
			$downloadBtn.css('display', 'block');
		} else {
			$downloadBtn.css('display', 'none');
			$iframeWrapper = $(photoSwipeElement).find('.en-pswp__iframe-wrapper');
		}

		// PhotoSwipe event before changing slides
		photoSwipeInstance.listen('beforeChange', function () {
			if (photoSwipeInstance.currItem.src) {
				$downloadBtn.attr('href', photoSwipeInstance.currItem.enOriginalImageUrl || photoSwipeInstance.currItem.src);
				$downloadBtn.css('display', 'block');
			} else {
				$downloadBtn.css('display', 'none');
				$iframeWrapper = $(photoSwipeElement).find('.en-pswp__iframe-wrapper');
			}
		});

		// PhotoSwipe event upon closing the gallery
		photoSwipeInstance.listen('close', close);

		createBullets(photoSwipeItems.length);

		return photoSwipeInstance;
	};

	/**
	 * Hide PhotoSlide element.
	 * @memberof module:PhotoSwipe
	 */
	var close = function () {
		if ($iframeWrapper) $iframeWrapper.remove();
		if (photoSwipeInstance && typeof photoSwipeInstance.close === 'function') photoSwipeInstance.close();
	};

	/**
	 * Sets up all event listeners and sets options.
	 * @memberof module:PhotoSwipe
	 * @param {object} [settings] - Overrides defaults, see below.
	 * @property {string} selector=".en-photoswipe-trigger[href]" - Element selector for the trigger elements.
	 * @property {string} scope - Selector to group elements so that the lightbox doesn't include all elements on the page.
	 * @property {string} container="body" - Element selector to place the lightbox in.
	 * @property {object} classNames - Collection of class names that are set by the module.
	 * @property {object} dataAttributes - Collection of data attribute names that are set by the module.
	 */
	var init = function (settings) {
		if (typeof PhotoSwipePlugin !== 'undefined' || typeof PhotoSwipePluginUI !== 'undefined') {
			options = $.extend({}, defaults, settings);
			photoSwipeElement = $(options.selectors.photoSwipeElement).get(0);

			if (!$(options.selectors.trigger).length) {
				return false;
			}

			if (!photoSwipeElement) {
				console.error('PhotoSwipe.js cannot find the photoSwipeElement in the DOM. Make sure to add it before initializing.');
				return false;
			}

			// firefox > 59 triggers the click event twice – WTF!
			// the first of the two is triggered on the original element
			// this leads to problems when closing photoswipe
			// prevent that by throttling the function
			var _open = lodash.throttle(function () {
				var $this = $(this);
				var $scope = $this.parents(options.selectors.scope);
				var $elements, index;
				var startIndex = parseInt($this.attr(options.dataAttributes.startIndex));

				if (!$scope.length) {
					$scope = $(document.body);
				}

				$elements = $scope.find(options.selectors.trigger);
				index = !isNaN(startIndex) ? startIndex : $elements.index($this);

				open($elements, index);
			}, 50, {
				leading: false,
				trailing: true,
			});

			// open the lightbox on click
			$(document).on('click.PhotoSwipe', options.selectors.trigger, function (e) {
				e.preventDefault();
				_open.apply(this);
			});

			// bullet navigation
			$(document).on('click.PhotoSwipe touchstart.PhotoSwipe', '.' + options.classNames.bullet, function () {
				if (photoSwipeInstance) {
					photoSwipeInstance.goTo($(this).index());
				}
			});
		}
		else {
			console.error('PhotoSwipe.js requires the PhotoSwipe plugin. Make sure to include it before initializing.');
		}
	};

	var getPhotoSwipeItemsFromElements = function ($elements) {
		var items = [];

		$elements.each(function (index, element) {
			var $element = $(element);
			var item = options.callbacks.itemFromElement($element, index, options);
			if (item) items.push(item);
		});

		return items;
	};

	/**
	 * Preload images
	 * @memberof module:PhotoSwipe
	 *
	 *
	 */
	var preload = function ($element) {
		var item = options.callbacks.itemFromElement($element, undefined, options);
		var image = new Image;
		image.src = item.src;
	};

	/**
	 * Trigger
	 *
	 * @param int count
	 */
	var preloadImages = function (count, force) {
		count = parseInt(count) > 0 ? parseInt(count) : 1;
		if (imagesPreloaded < count || force) {
			imagesPreloaded = count;

			var $scopes = $(options.selectors.scope);
			$scopes.each(function () {
				var $elements = $(this).find(options.selectors.trigger);
				$elements = $elements.slice(0, count);
				$elements.each(function () {
					preload($(this));
				});
			});
		}

	};

	// exports
	return {
		init: init,
		open: open,
		close: close,
		preloadImages: preloadImages
	};
}(jQuery, PhotoSwipe, PhotoSwipeUI_Default, lodash));
